import { Link } from "react-router-dom";
import { ArrowRight, Users, UserCheck, Route, CalendarDays, BadgeDollarSign, Wallet, AlertTriangle, FileClock, Search, Plus } from "lucide-react";
import { DriverHomeBold, NewTripBold } from "@/pages/preview/BoldDriver";

const B = "#0047AB";
const STATS = [[Users, "إجمالي السائقين", "24", 1], [UserCheck, "النشطون", "21", 0], [Route, "نقلات اليوم", "13", 1], [CalendarDays, "نقلات الشهر", "318", 0],
  [BadgeDollarSign, "المحصّل (د.ك)", "4,250", 0], [Wallet, "غير المدفوع (د.ك)", "780", 1], [AlertTriangle, "المخالفات", "7", 0], [FileClock, "مستندات تنتهي", "5", 1]];

function AdminBold() {
  return (
    <div className="rounded-3xl overflow-hidden border-[3px] bg-white" style={{ borderColor: B, fontFamily: "'Almarai', sans-serif" }} data-testid="bold-admin">
      <div className="text-white p-5 flex flex-wrap items-center gap-4" style={{ background: B }}>
        <img src="/img/logo.png" alt="" className="w-16 h-16 rounded-full bg-white p-0.5 object-contain" />
        <h2 className="text-3xl font-black flex-1">لوحة التحكم</h2>
        <div className="h-12 rounded-2xl bg-white flex items-center gap-2 px-4 font-bold text-slate-500 w-80 max-w-full"><Search className="w-5 h-5" style={{ color: B }} />بحث: سائق، 22/5382، نقلة...</div>
        <span className="h-12 rounded-2xl bg-white px-5 flex items-center gap-2 font-black" style={{ color: B }}><Plus className="w-6 h-6" strokeWidth={3} />إضافة</span>
      </div>
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 p-4">
        {STATS.map(([I, l, v, solid]) => (
          <div key={l} className="rounded-3xl p-4 border-[3px] flex items-center gap-3" style={{ borderColor: B, background: solid ? B : "#fff", color: solid ? "#fff" : B }}>
            <I className="w-11 h-11 shrink-0" strokeWidth={2.4} />
            <div><div className={`text-sm font-black ${solid ? "text-white/85" : "text-slate-600"}`}>{l}</div><div className="text-3xl font-black">{v}</div></div>
          </div>
        ))}
      </div>
      <div className="px-4 pb-4">
        <table className="w-full text-right font-bold">
          <thead><tr className="text-white" style={{ background: B }}>{["رقم النقلة", "السائق", "السيارة", "المبلغ", "الدفع"].map((h) => <th key={h} className="p-3">{h}</th>)}</tr></thead>
          <tbody>{[["TRP-000318", "محمد العنزي", "21/45454", "25.000", "مدفوع", "bg-green-600"], ["TRP-000317", "أحمد سالم", "34/11872", "40.000", "غير مدفوع", "bg-red-600"]].map(([n, d, p, m, s, c]) => (
            <tr key={n} className="border-b-2 border-slate-100"><td className="p-3" style={{ color: B }}>{n}</td><td className="p-3">{d}</td><td className="p-3"><span dir="ltr">{p}</span></td><td className="p-3"><span dir="ltr">{m}</span></td><td className="p-3"><span className={`text-white px-3 py-1 rounded-xl text-sm ${c}`}>{s}</span></td></tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}

export default function DesignBold() {
  return (
    <div className="min-h-screen bg-slate-100 p-4 lg:p-8 space-y-5" data-testid="design-bold-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h1 className="text-2xl font-black">عينة: تصميم جريء وعملي — أزرق وأبيض</h1>
          <p className="text-slate-600 text-sm">أزرار كبيرة، خطوط عريضة، إطارات واضحة، وتباين عالٍ يُقرأ تحت الشمس — بيانات توضيحية فقط</p></div>
        <Link to="/admin" data-testid="bold-back" className="btn btn-sm btn-ghost"><ArrowRight className="w-4 h-4" />العودة للنظام</Link>
      </div>
      <div className="grid md:grid-cols-2 gap-6 max-w-[820px] mx-auto">
        <div><h3 className="font-black text-center mb-2">الشاشة الرئيسية للسائق</h3><DriverHomeBold /></div>
        <div><h3 className="font-black text-center mb-2">تسجيل نقلة جديدة</h3><NewTripBold /></div>
      </div>
      <h3 className="font-black text-lg">واجهة الإدارة</h3>
      <AdminBold />
    </div>
  );
}
